module.exports = __webpack_public_path__ + "static/media/IconEye.2e36c72e.svg";